export default __webpack_public_path__ + "static/media/16.1d0d415a.png";